import { Vue } from "@/public/utils/customVue";
import Vuex, { Module } from "vuex";
import ui from "./modules/ui";
import shape from "./modules/shape";
import page from "./modules/page";
import gantt from "./modules/gantt";
import orgchart from "./modules/orgchart";
import mindmaster from "./modules/mindmaster";
import echart from "./modules/echart";
import table from "./modules/table";
import user from "./modules/user";
import dialog from "./modules/dialog";
import bindPhoneDialog from "./modules/bindPhoneDialog";
import library from "./modules/library";
import datasheet from "./modules/datasheet";
import version from "./modules/version";
import publicStore from "@/public/store/publicStore.js";
import nps from "./modules/nps";
import floatTool from "./modules/floatTool";
import staticConfig from "./modules/staticConfig";
import vipState from "./modules/vipState";
import thirdpart from "./modules/thirdpart";
import newEchart from "./modules/newEchart";
Vue.use(Vuex);

let $edApi = Vue.prototype.$edApi;

export default new Vuex.Store({
    state: {
        showMiniprogram: false,
        miniprogramLeft: 0,
        miniprogramTop: 0,
        miniprogramDirection: 0, // 上下左右 位运算第一位控制上下，第二位控制左右
    },
    modules: {
        ui,
        nps,
        user,
        gantt,
        page,
        shape,
        orgchart,
        mindmaster,
        echart,
        table,
        dialog,
        bindPhoneDialog,
        library,
        datasheet,
        version,
        publicStore,
        floatTool,
        staticConfig,
        vipState,
        thirdpart,
        newEchart,
    },
    mutations: {
        openOnlineSupport(state, payload) {
            const { internal } = payload;
            if (internal) {
                window.open("https://msg.wondershare.cc/qidian_edrawmax_client.html");
            } else {
                if (window["wsCrmChatbotApi"] && window["wsCrmChatbotApi"].click2HandleChatbot) {
                    window["wsCrmChatbotApi"].click2HandleChatbot();
                }
            }
        },
        setMiniProgram(state, obj) {
            state.showMiniprogram = obj.show;
            state.miniprogramLeft = obj.left;
            state.miniprogramTop = obj.top;
            state.miniprogramDirection = obj.direction;
        },
        invalidToken(state: any) {
            state.user.userInfo = "";
        },
    },
    actions: {
        uploadFile({ state, rootGetters, commit, rootState }, obj) {
            let runplatform = rootState["publicStore"].runPlatform;
            return new Promise((resolve, reject) => {
                let params = Object.assign(
                    {
                        obj: obj.name,
                        size: obj.file.size,
                        encrypt: obj.encrypt || 0,
                        platform: runplatform,
                    },
                    rootGetters.apiParam
                );
                $edApi
                    .getCloudFileSign(params)
                    .then((res) => {
                        if (res.msg === "file num over limit") {
                            commit("toPublicStatus", {
                                type: "showUpgrade",
                                data: "fileNum",
                            });
                            reject("overLimit");
                        } else if (res.msg === "storage space not enough") {
                            reject("storage space not enough");
                        } else {
                            let user = (state as any).user;
                            let ossParams = {
                                url: `${user.userInfo.user_name}/Personal/${obj.name}`,
                                exp: res.data.exp,
                                sign: res.data.sign,
                                file: obj.file,
                                contentType: "application/octet-stream",
                            };
                            $edApi.uploadOSSFile(ossParams).then((res) => {
                                resolve({
                                    res,
                                    path: `${user.userInfo.user_name}/Personal/${obj.name}`,
                                });
                            });
                        }
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    },
});
